export enum EFolderPlatformStatus {

    Ongoing     = 'ongoing',
    Validated   = 'validated',
    Refused     = 'refused',
}
